<template>
  <b-navbar toggleable="md" type="dark" variant="primary">
    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
    <b-navbar-brand to="index"><i class="fa fa-globe"></i> ALFP</b-navbar-brand>
    <b-collapse is-nav id="nav_collapse">
      <b-navbar-nav>
        <b-nav-item :to="{ name: 'index' }">Home</b-nav-item>
        <b-nav-item-dropdown text="About">
          <b-dropdown-item :to="{ name: 'about.history' }"
            >History</b-dropdown-item
          >
          <b-dropdown-item :to="{ name: 'about.executive_summary' }"
            >Executive Summary</b-dropdown-item
          >
          <b-dropdown-item :to="{ name: 'about.organization_tree' }"
            >Organizational Chart</b-dropdown-item
          >
          <b-dropdown-item :to="{ name: 'committees.list' }"
            >Committees</b-dropdown-item
          >
        </b-nav-item-dropdown>
        <b-nav-item-dropdown text="Research">
          <b-dropdown-item :to="{ name: 'research.publications' }"
            >Publications</b-dropdown-item
          >
          <b-dropdown-item :to="{ name: 'research.stakeholders_conference' }"
            >Stakeholders Conference</b-dropdown-item
          >
        </b-nav-item-dropdown>
        <b-nav-item-dropdown text="Resources">
          <b-dropdown-item :to="{ name: 'resources.list' }"
            >Links</b-dropdown-item
          >
          <b-dropdown-item :to="{ name: 'resources.map' }"
            >ALFP Therapist Directory</b-dropdown-item
          >
          <b-dropdown-item :to="{ name: 'resources.registration' }"
            >Register as a Specialist</b-dropdown-item
          >
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item :to="{ name: 'dashboard.view' }"
            >Specialist Dashboard</b-dropdown-item
          >
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item :to="{ name: 'sosido.registration' }"
            >Register for Sosido</b-dropdown-item
          >
        </b-nav-item-dropdown>
        <b-nav-item :to="{ name: 'industry.partners' }">Connect</b-nav-item>
        <b-nav-item-dropdown text="Contact">
          <b-dropdown-item :to="{ name: 'contact.us' }"
            >Contact Us</b-dropdown-item
          >
          <b-dropdown-item :to="{ name: 'contact.lta' }"
            >Lymphedema Treatment Act</b-dropdown-item
          >
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import Relay from "system/relay";
import Store from "system/store";
export default {
  data() {
    return { state: Store.state };
  },
  methods: {
    logout: function() {
      Relay.get("SecureUser", { act: "logout" }, () => {
        Store.commit("deauthorize");
        Relay.clearTokens();
        location.href = "/";
      });
    }
  }
};
</script>
